import { zergApi } from "@/service/zerg";

class TransactionTypesService {

    async getTransactionTypes(params) {
        try {
            const data = await zergApi.get("/bookeeping/transaction-types/index", { params });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new TransactionTypesService();